import { API_URL } from '../config/connect';
import { apiFetch } from '../utils/apiErrorHandler';

/**
 * Halyk ePay — төлем сілтемесін алу.
 * POST /api/v1/halyk-payment/generate
 * Жауап: { invoice_url, invoice_id } — invoice_url-ге redirect жасау керек.
 *
 * @param {number} amount - Сумма пополнения (KZT)
 * @param {string} [currency='KZT'] - Валюта (3 символа)
 * @returns {Promise<{ invoice_url: string, invoice_id: number }>}
 */
export async function halykPaymentGenerate(amount, currency = 'KZT') {
    const accessToken = localStorage.getItem('access_token');
    if (!accessToken) {
        throw new Error('Authorization token is missing');
    }

    const data = await apiFetch(`${API_URL}/api/v1/halyk-payment/generate`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
            amount: Number(amount),
            currency,
        }),
    });

    if (!data?.invoice_url) {
        throw new Error('Invalid response: missing invoice_url');
    }

    return data;
}
